import { h } from 'preact';

// @ts-ignore
import licensesFront from '../../../assets/licenses_frontend.json';
// @ts-ignore
import licensesServer from '../../../assets/licenses_server.json';

export function InfoPanel(props: {
    visible: boolean,
    setPanel: (to: string | null) => any
}) {
    
    return <aside className='x-info-floater'
            data-visible={`${props.visible}`}
            >
        <header>
            <button
                onClick={e => {
                    e.preventDefault();
                    props.setPanel(null);
                }}
                >&lArr; Palaa</button>
        </header>
        <div>
            
            <div style={{ textAlign: 'center' }}>
                <h1>Ukkoskartta<sup>☁️</sup></h1>
                <p>&copy; Roni Lehto 2026</p>
                <p><a href="https://lehtodigital.fi/">www.lehtodigital.fi</a> / <a href="https://purnu.dy.fi/">purnu.dy.fi</a></p>
                <p>Forkkaa <a href="https://github.com/lehtoroni/ukkoskartta">GitHubissa</a>!</p>
            </div>
            
            <div className='issue'>
                <h3>Tärkeää!</h3>
                <p>
                    Ukkoskartta on harraste&shy;pohjalta tehty työkalu joka näyttää FMI:n avointa dataa.
                    Tätä työkalua <b><u>ei saa käyttää</u></b> ihmisten tai omaisuuden suoje&shy;luun, ammattilais&shy;käyttöön tai muihin tärkei&shy;siin tarkoi&shy;tuksiin.
                </p>
            </div>
            
            <hr/>
            
            <h3>Merkit</h3>
            
            <p>Väri kuvastaa salamahavainnon ikää</p>
            <p>
                <img src={new URL('../../../assets/tick_white.png', import.meta.url).href}/>  0–5 minuuttia <br/>
                <img src={new URL('../../../assets/tick_yellow.png', import.meta.url).href}/>  5–10 minuuttia <br/>
                <img src={new URL('../../../assets/tick_orange.png', import.meta.url).href}/>  10–15 minuuttia <br/>
                <img src={new URL('../../../assets/tick_red_2.png', import.meta.url).href}/>  15–30 minuuttia <br/>
                <img src={new URL('../../../assets/tick_darkred.png', import.meta.url).href}/>  30–45 minuuttia <br/>
                <img src={new URL('../../../assets/tick_darkred2.png', import.meta.url).href}/>  45+ minuuttia
            </p>
            
            <p>Muoto kuvastaa salamahavainnon tyyppiä ("cloudindicator" vai ei)</p>
            <p>
                <img src={new URL('../../../assets/tick_white.png', import.meta.url).href}/>  maasalama <br/>
                <img src={new URL('../../../assets/tick_white_cloud.png', import.meta.url).href}/>  pilvisalama
            </p>
            
            <hr/>
            
            <p>Ukkoskartta ei toimisi ilman seuraavaksi mainittavia apuvälineitä ja Ilmatieteen laitoksen avointa dataa.</p>
            
            <hr/>
            
            <h3>Karttatasot</h3>
            <p>Karttatyökalu &copy; <a href="https://leafletjs.com/" target='_blank'>Leaflet</a> ja tekijät</p>
            <p>Karttakuvat &copy; <a href="https://openfreemap.org/" target='_blank'>OpenFreeMap</a> ja tekijät</p>
            
            <hr/>
            
            <h3>Salamatutkadata</h3>
            <p>
                Ukkoskartta käyttää <a href='https://www.ilmatieteenlaitos.fi/avoin-data' target='_blank'>Ilmatieteen Laitoksen avointa dataa</a>: Salamahavainnot.
            </p>
            
            <hr/>
            
            <h3>Ohjelmakirjastot ja -työkalut</h3>
            <p>&nbsp;</p>
            
            <h4>Frontend</h4>
            {licensesFront.map((dep: any) =>
                <div key={dep.name} style={{ marginBottom: '16px' }}>
                    <p className='mb-1'><b>{dep.name}</b> {dep.installedVersion}</p>
                    <p className='mb-1'><a href={dep.link} target='_blank' rel='nofollow'>{dep.link}</a></p>
                    <p className='mb-1'>Tekijä: {dep.author}</p>
                    <p>Lisenssi: {dep.licenseType}</p>
                </div>
            )}
            
            <p>&nbsp;</p>
            <h4>Backend</h4>
            {licensesServer.map((dep: any) =>
                <div key={dep.name} style={{ marginBottom: '16px' }}>
                    <p className='mb-1'><b>{dep.name}</b> {dep.installedVersion}</p>
                    <p className='mb-1'><a href={dep.link} target='_blank' rel='nofollow'>{dep.link}</a></p>
                    <p className='mb-1'>Tekijä: {dep.author}</p>
                    <p>Lisenssi: {dep.licenseType}</p>
                </div>
            )}
            
        </div>
    </aside>;
    
}